import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">
          Política de Privacidad
        </h1>
        <p className="text-gray-600 mb-8">Última actualización: Julio 2026</p>

        <div className="space-y-6">
          <p className="text-gray-700 leading-relaxed">
            En Video Vault valoramos la privacidad y buscamos recolectar la menor cantidad de información
            posible para operar de forma segura y estable.
          </p>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">1) Qué información recolectamos</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <h3 className="font-semibold text-black mb-2">Información técnica básica:</h3>
                <p className="text-gray-700">
                  Tipo de navegador, sistema operativo, dirección IP (generalmente en logs del servidor),
                  fecha/hora, páginas visitadas y eventos de error.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-black mb-2">Información de rendimiento y seguridad:</h3>
                <p className="text-gray-700">
                  Métricas agregadas para detectar abuso, ataques o fallos.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border">
                <p className="text-gray-700 font-medium">
                  <strong>Importante:</strong> no solicitamos cuenta y no requerimos datos personales
                  para usar la herramienta.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">2) Enlaces ingresados</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Los enlaces que ingresás se usan únicamente para procesar la solicitud. No creamos un
                "historial personal" de enlaces, y no vendemos esa información.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">3) Cookies</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 mb-4">Usamos almacenamiento local y, según tus decisiones, tecnologías similares para:</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Preferencias básicas (por ejemplo, idioma).</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Seguridad (prevención de abuso).</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Publicidad mediante Google AdSense, sujeto al consentimiento aplicable.</span>
                </li>
              </ul>
              <p className="text-gray-700 mt-4">
                Google AdSense puede usar cookies, direcciones IP u otros identificadores para servir y medir publicidad. Google Analytics solo se carga si lo aceptás. Estos proveedores pueden usar tecnologías
                similares para mostrar anuncios relevantes o medir rendimiento, de acuerdo con sus propias políticas.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">4) Publicidad y analítica</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Mostramos anuncios mediante Google AdSense para mantener el servicio. Google y sus socios pueden
                recolectar datos técnicos para medición de anuncios. Podés aceptar o rechazar Google Analytics desde el aviso del sitio. Para publicidad, usamos la gestión de consentimiento de Google cuando corresponde. También podés revisar la configuración
                de privacidad del navegador y, si aplica, el consentimiento de cookies.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">5) Retención</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Los registros técnicos se conservan por un período limitado para seguridad y diagnóstico
                y luego se eliminan o anonimizan.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-xl">6) Enlaces a terceros</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Este sitio puede enlazar a páginas externas. No controlamos sus prácticas de privacidad.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2 bg-gray-50">
            <CardHeader>
              <CardTitle className="text-xl">7) Contacto</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Si tenés preguntas sobre privacidad, escribinos a{' '}
                <a href="mailto:support@cloudcentercr.com" className="font-semibold text-black hover:underline">
                  support@cloudcentercr.com
                </a>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
